import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { AWAssetDto, AWStageDto } from '@api/Api';
import { useCurrentStage } from '@hooks/useCurrentStage';
import { ClockIcon } from '@icons';

type OverdueMediaCellProps = {
  stages: AWStageDto[];
  assets: AWAssetDto[];
  currentStageId?: string | null;
  isFinished: boolean;
  isPaused: boolean;
};

export default memo(function OverdueMediaCell({
  stages,
  assets,
  currentStageId,
  isPaused,
  isFinished
}: OverdueMediaCellProps) {
  const { currentStage, isPastDueDate } = useCurrentStage({
    stages,
    currentStageId,
    isFinished,
    isPaused
  });

  const currentMember = useMemo(
    () => currentStage?.members.find((member) => member.me),
    [currentStage?.members]
  );

  const toReviewCount = useMemo(() => {
    if (!currentMember?.canSubmitDecision) {
      return 0;
    }
    return assets.length;
  }, [assets.length, currentMember?.canSubmitDecision]);

  const reviewCount = useMemo(() => {
    if (!currentMember?.canSubmitDecision) {
      return 0;
    }
    return assets.filter((asset) =>
      currentMember?.decisions?.some(
        (x) => x.assetVersionId === asset.versionId && x.decision
      )
    ).length;
  }, [assets, currentMember?.canSubmitDecision, currentMember?.decisions]);

  const canReview = toReviewCount > 0;

  if (isFinished) return '-';
  if (isPaused) return '-';
  if (!canReview) return '-';
  if (!isPastDueDate) return '-';

  return (
    <div className={classNames('overdue-media-cell')}>
      <ClockIcon style={{ fontSize: 16 }} />
      {toReviewCount - reviewCount}
    </div>
  );
});
